module.exports = __webpack_public_path__ + "img/材料力学8_5_2.50701ab1.jpg";